import { Component, inject } from '@angular/core';
import { StandardPageLayoutComponent } from '@layouts/pages/standard-page-layout/standard-page-layout.component';
import { ProgrammePageService } from './programme-page.service';
import { ProgrammePage } from '@features/models/events/programmes/programme-page';
import { ActivatedRoute } from '@angular/router';
import { UserService } from '@core/services/user.service';
import { ProgrammePerformanceListComponent } from '@features/components/events/programme-performance-list/programme-performance-list.component';
import { ProgrammePerformanceRankingComponent } from '@features/components/events/programme-performance-ranking/programme-performance-ranking.component';
import { PerformanceItemRankingData } from '@features/models/fans/performance-item-rankings/performance-item-ranking-data';
import { ProgrammePerformanceItemRankingChange } from '@features/models/fans/performance-item-rankings/programme-performance-item-ranking-change';
import { PerformanceItemRatingData } from '@features/models/fans/performance-item-ratings/performance-item-rating-data';

@Component({
  selector: 'app-programme-page',
  imports: [StandardPageLayoutComponent, ProgrammePerformanceListComponent, ProgrammePerformanceRankingComponent],
  templateUrl: './programme-page.component.html',
  providers: [ProgrammePageService]
})
export class ProgrammePageComponent {

  private _programmePageService = inject(ProgrammePageService);
  public _userService = inject(UserService);
  private _route = inject(ActivatedRoute);

  private programmeId?: string | null;
  public selectedView: 'actOrder' | 'ranking' = 'actOrder';

  public pageData?: ProgrammePage;

  ngOnInit(): void {
    this.programmeId = this._route.snapshot.paramMap.get('id');

    if (this.programmeId) {
      this._programmePageService.getProgramme(this.programmeId).subscribe(pageData => {
        this.pageData = pageData;
      });
    }
  }

  public formatFromToDate(from?: string, to?: string): string {
      let fromToLabel: string | null = null;
  
      if (from) {
        var fromDate = new Date(from);
        const fromDay = fromDate.getDate();
        const fromMonth = fromDate.toLocaleString('default', { month: 'short' });
        fromToLabel = `${fromDay} ${fromMonth}`;
      }
  
      /*ActivatedRouteif (to) {
        var toDate = new Date(to);
        const toDay = toDate.getDate();
        const toMonth = toDate.toLocaleString('default', { month: 'short' });
  
        if ((fromToLabel?.length ?? 0) > 0) {
          fromToLabel = `${fromToLabel} to ${toDay} ${toMonth}`;
        } else {
          fromToLabel = `${toDay} ${toMonth}`;
        }
      }*/
  
      return fromToLabel ?? 'Dates to be announced';
    }

    onPerformanceItemRankedList(
      performanceItemRankedList: PerformanceItemRankingData[]
    ): void {
      if (!this.programmeId) return;

      if (this.pageData?.performanceItemRankingList) {
        performanceItemRankedList.forEach(ranking => {
          var rankingData = this.pageData?.performanceItemRankingList?.find(rankingData =>
            rankingData.performanceItemId === ranking.performanceItemId
          )

          if (rankingData) {
            rankingData.ranking = ranking.ranking;
            rankingData.locked = ranking.locked;
            rankingData.comment = ranking.comment;
          }
          else {
            this.pageData!.performanceItemRankingList?.push(ranking);
          }
        });
      }
      
      this._programmePageService.postProgrammePerformanceItemRankingChange(
        new ProgrammePerformanceItemRankingChange(
          this.programmeId,
          performanceItemRankedList
        ));
    }

    onPerformanceItemRated(
      performanceItemRating: PerformanceItemRatingData
    ): void {

      if (this.pageData?.performanceItemRatingList) {
          var ratingData = this.pageData?.performanceItemRatingList?.find(ratingData =>
            ratingData.performanceItemId === performanceItemRating.performanceItemId
          )

          if (ratingData) {
            ratingData.rating = performanceItemRating.rating;
            ratingData.trim = performanceItemRating.trim;
            ratingData.comment = performanceItemRating.comment;
          }
          else {
            this.pageData!.performanceItemRatingList.push(performanceItemRating);
          }
      }

      this._programmePageService.postProgrammePerformanceItemRatingChange(
        {...performanceItemRating}
      );
    }

}
